import io from 'socket.io-client';

export const socket = io("https://chatapp-nxzf.onrender.com");
